
import * as React from "react";

function MailIcon(props) {
  return (
    <svg viewBox="0 0 26.45 19.77" {...props}>
      <g data-name="Layer 2">
        <g data-name="Layer 1" fill="none" stroke="#333">
          <path strokeMiterlimit={10} d="M.5.5h25.45v18.77H.5z" />
          <path
            strokeLinejoin="round"
            d="M13.23 11.35L.5.5h25.45L13.23 11.35z"
          />
        </g>
      </g>
    </svg>
  );
}

const MemoMailIcon = React.memo(MailIcon);
export default MemoMailIcon;
